module.exports = __webpack_public_path__ + "static/img/tga.2577797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/tga.png
// module id = xGE1
// module chunks = 53